import React from "react";

export interface LabelProps {
  Icon?: string | React.ComponentType<any> | null;
  text: string;
  link?: string;
}

export const Label: React.FC<LabelProps> = ({ Icon, text, link }) => {
  const renderInner = () => (
    <>
      {Icon && typeof Icon === "string" && (
        <span
          className="label__icon"
          dangerouslySetInnerHTML={{ __html: Icon }}
        />
      )}
      {Icon && typeof Icon !== "string" && (
        <span className="label__icon">
          <Icon />
        </span>
      )}
      <span className="label__text">{text}</span>
    </>
  );

  if (link) {
    return (
      <a className="label is-light" href={link}>
        {renderInner()}
      </a>
    );
  }

  return <span className="label is-light">{renderInner()}</span>;
};
